import { enqueueSnackbar, SnackbarKey, SnackbarMessage, OptionsObject } from 'notistack';
import { HEBREW_SNACKBAR } from 'utils/whatsappErrors';

/** הודעות ברירת מחדל בעברית — לשימוש עקבי בכל האפליקציה */
export const snackbarHebrew = {
  ...HEBREW_SNACKBAR,
} as const;

export function enqueueErrorHebrew(
  message: SnackbarMessage = snackbarHebrew.genericError,
  options?: OptionsObject,
): SnackbarKey {
  return enqueueSnackbar(message, { variant: 'error', ...options });
}

export function enqueueSuccessHebrew(
  message: SnackbarMessage = snackbarHebrew.genericSuccess,
  options?: OptionsObject,
): SnackbarKey {
  return enqueueSnackbar(message, { variant: 'success', ...options });
}

export function enqueueNetworkErrorHebrew(options?: OptionsObject): SnackbarKey {
  return enqueueSnackbar(snackbarHebrew.networkError, { variant: 'warning', ...options });
}
